import { render, staticRenderFns } from "./DS.vue?vue&type=template&id=00f2b32c&scoped=true"
import script from "./DS.vue?vue&type=script&lang=js"
export * from "./DS.vue?vue&type=script&lang=js"
import style0 from "./DS.vue?vue&type=style&index=0&id=00f2b32c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f2b32c",
  null
  
)

export default component.exports